export default __webpack_public_path__ + "static/media/124.2a981df2.jpg";